import { Box, CircularProgress } from "@mui/material";

type Props = {
  progress?: number;
};

/** File transfer progress 0-100, or -1 for intermediate spinner, or undefined to hide */
export default function FileProgressSpinner({ progress }: Props) {
  return (
    <Box sx={{ margin: "12px 8px 0 12px", minWidth: "30px" }}>
      {progress != undefined &&
        (progress < 0 ? (
          <CircularProgress size={"24px"} />
        ) : (
          <CircularProgress variant="determinate" value={progress} size={"24px"} />
        ))}
    </Box>
  );
}
